import React, { useEffect } from "react";
import { setWithExpiry, getWithExpiry } from "../../utils/ErrorFunctions";

export default function ErrorFallback({ error, resetErrorBoundary }) {
  // Handle failed lazy loading of a JS/CSS chunk.
  useEffect(() => {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (error?.message && chunkFailedMessage.test(error.message)) {
      if (!getWithExpiry("chunk_failed")) {
        setWithExpiry("chunk_failed", "true", 5000);
        window.location.reload();
      }
    }
  }, [error]);

  return (
    <div className="text-center pt-28">
      <p>Something went wrong.</p>
      {process.env.NODE_ENV === "development" && (<pre>{error?.message}</pre>)}
      <button onClick={resetErrorBoundary} className="mt-1 py-1 px-2 bg-green-1 text-white font-normal rounded cursor-pointer hover:bg-success-hover">Try again</button>
    </div>
  );
}
